let TemplateContent = function () {

    //****************************************************************
    // Init
    //****************************************************************

    const _init = function () {
        $('[data-module="content"]').each(function () {
            let $module = $(this);
            let skus = _collectProductSkusInModule($module);

            if (skus.length > 0) {
                _initModuleWithProductTiles($module, skus);
            } else if ($module.is('[data-carrousel]')) {
                _initModuleSlider($module);
            }
        });
    };

    const _initModuleSlider = function ($sliderModule) {
        if ($sliderModule && !$sliderModule.hasClass('slick-initialized')) {
            let itemsCarrouselMobile = $sliderModule.data('items-mobile') || 1;
            let itemsCarrouselTablet = $sliderModule.data('items-tablet') || 2;
            let itemsCarrouselDesktop = $sliderModule.data('items-desktop') || 4;

            let $unEqualTile = $sliderModule.find('.unEqualTile');
            if ($unEqualTile.length) {
                _templateCarouselBeforeChange($sliderModule, $unEqualTile);
            }

            templateSlick($sliderModule, itemsCarrouselMobile, itemsCarrouselTablet, itemsCarrouselDesktop, $unEqualTile);
        }
    };

    //****************************************************************
    // Util
    //****************************************************************

    const _collectProductSkusInModule = function ($module) {
        let uniqueSkus = new Set($module.find('[data-inject-sku]').map(function () {
            return String($(this).attr('data-inject-sku'));
        }).get());

        return Array.from(uniqueSkus);
    };


    //****************************************************************
    // Ajax
    //****************************************************************

    const _initModuleWithProductTiles = function ($container, productIds) {
        if (productIds.length > 0 && $container.length) {
            TINK.inProgress($container);
            $.ajax({
                url: searchProductsByIdsUrl,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    productIds: productIds
                }),
                headers: {
                    'Accept-Language': lang
                },
                cache: false,
                success: function (data) {
                    data = data.trim();
                    let $data = $(data);
                    for (let i = 0; i < productIds.length; i++) {
                        let productId = productIds[i];
                        let $productContainer = $container.find('[data-inject-sku=' + productId + ']');
                        let $productTile = $data.find('.item-addToCart[data-product-code="' + productId + '"]');
                        $productTile.length > 0 ? $productContainer.append($productTile) : $productContainer.remove();
                    }

                    if ($container.is('[data-carrousel]')) {
                        _initModuleSlider($container);
                    }
                    TINK.stopProgress($container);
                },
                error: function () {
                    let $moduleTemplateContainer = $container.parents('.module-template');
                    $moduleTemplateContainer.length > 0 ? $moduleTemplateContainer.remove() : $container.remove();
                }
            });
        }
    };

    //****************************************************************
    // Slider
    //****************************************************************

    const _templateCarouselBeforeChange = function ($slider, elm) {
        let initialScreenWidth = $(window).width();

        $(window).on('resize', _.debounce(function () {
            let screenWidth = $(window).width();
            if (initialScreenWidth >= 980 && screenWidth < 980) {
                $slider.slick('unslick');
                $slider.find('.tile--empty').remove();
                templateSlick($slider, 1, 2, 4, elm);
                initialScreenWidth = screenWidth;
            } else if (initialScreenWidth < 980 && screenWidth >= 980) {
                $slider.slick('unslick');
                $slider.find('.tile--empty').remove();
                templateSlick($slider, 1, 2, 4, elm);
                initialScreenWidth = screenWidth;
            }
        }, 1000));
    };

    //****************************************************************
    // Expose
    //****************************************************************

    return {
        init: _init,
    };
}();

$(function () {
    TemplateContent.init();
});